define('modules/lp_leads/index',['require','exports','module','base/router','lib/util','modules/lp_info/models/page','common/views/dashboard_layout','common/views/404','./views/main','./views/navigation','common/models/date_model'],function(require, exports, module){
	"use strict";

	var Router = require("base/router"),
			util = require("lib/util"),
			PageModel = require("modules/lp_info/models/page"),
			DashboardLayout = require("common/views/dashboard_layout"),
      View404 = require("common/views/404"),
			PageView = require("./views/main"),
      LeadsNavigationView = require("./views/navigation"),
      DateModel = require("common/models/date_model");

	module.exports = function(moduleManager){
		var ModuleRouter = Router.extend({
			routes: {
				"leads/:id": "index"
			},

			activatePagesTab: function(next) {
        $(".ed-navlink.active").removeClass("active");
        $(".js-pages").addClass("active");
      },

      index: function(id){
        var pageModel = new PageModel({ id: id }),
            layout = moduleManager.showInstance(DashboardLayout),
            dateModel = this._cloneDate(),
            viewOptions = {model: pageModel, date: dateModel},
            leadsNavigationView = new LeadsNavigationView(viewOptions),
            pageView =  new PageView(viewOptions);

        layout.$el.find('.ed-subnav').addClass('hidden');

        this.activatePagesTab();
        layout.showLoading();

        pageModel.fetch({
          success: function(){
            layout.$top.show(leadsNavigationView);
            layout.$content.show(pageView);
          },
          error: function(){
            layout.$content.show(new View404());
          }
        });
      },

      _cloneDate: function(oldDate) {
        var date = new DateModel();
        oldDate = oldDate || date;
        date.set(_.clone(oldDate.attributes), {silent: true});
        return date;
      }

		});
		return new ModuleRouter();
	};
});

